import PoolBasics, { I18N_CONTEXT } from './create_basics'
import { reduxForm } from 'redux-form'
import formUtils from 'lib/form_utils'
import { length, required, combine } from 'lib/validators'
import { endDateValidators } from 'lib/end_date_validators'
import { getI18n } from 'client/i18n'
import { TITLE_LENGTH } from 'shared/lengths'
import { push } from 'react-router-redux'
import { NEW_CAMPAIGN_ID, setData } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'

const i18n = getI18n(I18N_CONTEXT)

let validators = [
  length('poolName', TITLE_LENGTH, i18n('pool_name_too_long')),
  required('poolName', i18n('pool_name_is_required')),
  ...endDateValidators('endDate'),
]

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    shouldAutoFocus: props.router.params.action !== 'POP',
    initialValues: {
      poolName: campaign.title,
      goalAmount: campaign.goal,
      endDate: campaign.end_date ? new Date(campaign.end_date) : null,
      shareProgress: campaign.share_progress,
    },
  }
}

const mapDispatchToProps = dispatch => ({
  onSubmit(formValues) {
    dispatch(
      setData(NEW_CAMPAIGN_ID, {
        title: formValues.poolName,
        goal: formValues.goalAmount,
        end_date: formValues.endDate,
        share_progress: formValues.shareProgress,
      })
    )
    dispatch(
      push({ pathname: `${GLOBAL_CONSTS.REQUEST_URI}/c/create/preferences` })
    )
  },
})

export default reduxForm(
  {
    form: 'create_basics',
    destroyOnUnmount: false,
    validate: combine(...validators),
    touchOnBlur: true,
    touchOnChange: false,
    fields: ['poolName', 'goalAmount', 'endDate', 'shareProgress'],
  },
  mapStateToProps,
  mapDispatchToProps
)(formUtils(PoolBasics))
